import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/centercode': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M329.2 268.6c-3.8 35.2-35.4 60.6-70.6 56.8-35.2-3.8-60.6-35.4-56.8-70.6s35.4-60.6 70.6-56.8c35.1 3.8 60.6 35.4 56.8 70.6zM243.4 503.7c-146.7-7.7-251.6-138.2-233.3-279.4 11.2-86.6 65.8-156.9 139.1-192 161-77.1 349.7 37.4 354.7 216.6 4.1 147-118.4 262.2-260.5 254.8zM423.3 323.7c27.9-118-160.5-205.9-237.2-234.2-57.5 56.3-69.1 188.6-33.8 344.4 68.8 15.8 169.1-26.4 271-110.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/centercode.js
// module id = 750
// module chunks = 0